// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","logo":"Logo_logo__ibVcQ","image":"Logo_image__9famN","text":"Logo_text__e9OPu"};